import * as modules from "./modules/";
import config from "../../../../config";
const { vendor } = config;

const ActionInProgress = modules[vendor] ? modules[vendor] : modules["default"];

export default ActionInProgress;
